//import Account from './../../Resources/script.js'


import commonfunctions from "../../Resources/commonfunctions";
import OrderDetailsRequest from "./OrderDetailsRequest.vue";
export default {
    mixins: [commonfunctions],
    data () {
        return {}
    },
    components: {
        'order-request':OrderDetailsRequest,
    },
     
    methods: {

        setPage(){
            this.loading = true;
            //get Orders
            this.getAppBusinessOrders();
            //get prnding order payments
            this.getAppBusinessOrdersPendingPayments();
        },

      
    },

    created: function(){
        let self = this;
        localforage.getItem('xvue', function(err, value) { //quick with the callback version
            if(value != undefined) {
                self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                self.setPage();
            }else{}
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoint/Orders/script.js